import React, { useState } from 'react'
import {
    useLocation,
    useNavigate,
    useParams,
    useSearchParams,
} from 'react-router-dom'

import { Purchase, ContractPosition, ContractSupplier } from '../../../types'

// import FooterLeftToolbarButtons from './Buttons/FooterLeftToolbarButtons'
import FooterRightToolbarButtons from './Buttons/FooterRightToolbarButtons'
import FooterLeftToolbarButtons from './Buttons/FooterLeftToolbarButtons'

type NavState = {
    from?: 'purchase' | 'registry'
    purchaseRegNumber?: string
    fromStage?: string | null
    fromYear?: string | number | null
}

type Props = {
    theme: string
    purchaseAction: boolean
    purchaseGuid: string | undefined
    purchase: Purchase

    user_guid: string | null
    contract_user_guid: string
    contract_supervisor_user_guid: string
    role: string

    stage: string
    status: string
}

const Footer: React.FC<Props> = (props) => {
    const location = useLocation()
    const navigate = useNavigate()
    const params = useParams()

    const navState = (location.state ?? {}) as NavState

    const [isSaving, setSaving] = useState<boolean>(false)
    const [saveContractPopup, setSaveContractPopup] = useState<boolean>(false)

    const [isDeleting, setDeleting] = useState<boolean>(false)
    const [deleteContractPopup, setDeleteContractPopup] =
        useState<boolean>(false)

    const [toEisSendPopup, setToEisSendPopup] = useState<boolean>(false)
    const [isToEisSending, setToEisSending] = useState<boolean>(false)

    const [toEisSendResponsePopup, setToEisSendResponsePopup] =
        useState<boolean>(false)
    const [toEisSendResponse, setToEisSendResponse] = useState<any | null>(null)

    const [updateFromEisPopup, setUpdateFromEisPopup] = useState<boolean>(false)
    const [isUpdatingFromEis, setUpdatingFromEis] = useState<boolean>(false)
    const [popupMessage, setPopupMessage] = useState('')
    const [forceUpdateUrl, setForceUpdateUrl] = useState<string | null>(null)

    const [updateErrorPopup, setUpdateErrorPopup] = useState<boolean>(false)
    const [updateErrorText, setUpdateErrorText] = useState<string>('')

    const handleClose = () => {
        // если пришли из реестра — вернемся туда же и на ту же стадию
        if (navState.from === 'registry') {
            navigate(
                `/hub/purchases?year=${navState.fromYear}&stage=${navState.fromStage ?? props.stage}`,
                {
                    replace: true,
                }
            ) // <-- подставь свой реальный роут реестра
            return
        }

        // иначе (пришли из договора / нет state) — возвращаемся в договор
        const purchaseRegNumber =
            navState.purchaseRegNumber ?? params.purchaseRegNumber
        if (purchaseRegNumber) {
            navigate(
                `/hub/purchase/${purchaseRegNumber}?tab=${encodeURIComponent('Документация')}`,
                { replace: true }
            )
            return
        }

        // совсем fallback
        navigate('/hub/purchases', { replace: true })
    }

    return (
        <footer className="flex flex-row w-full min-h-10 items-center justify-end ">
            <div className="flex flex-row gap-2 p-2 px-[22px] w-full h-full bg-[#d2d5d8] dark:bg-[#262427] items-center justify-start">
                {/* <FooterLeftToolbarButtons
                    user_guid={props.user_guid}
                    contract_user_guid={props.contract_user_guid}
                    contract_supervisor_user_guid={
                        props.contract_supervisor_user_guid
                    }
                    role={props.role}
                    stage={props.stage}
                    status={props.status}
                    purchaseAction={props.purchaseAction}
                    approve={false}
                    isHaveError={false}
                    theme={props.theme}
                    lastApprovalStatus={true}
                    lastApprovalStatusAccept={true}
                    organizationApproval={false}
                    isUpdatingFromEis={isUpdatingFromEis}
                    actions={{
                        return_to_edit: () => {
                            handleStageChange(
                                props.purchase.guid,
                                'Редактирование'
                            )
                            handleStatusChange(props.purchase.guid, 'Черновик')
                        },
                        return_to_ready: () => {
                            handleStageChange(
                                props.purchase.guid,
                                'Подготовка к размещению'
                            )
                            handleStatusChange(
                                props.purchase.guid,
                                'Подготовка'
                            )
                        },
                        ready: () =>
                            handleStatusChange(props.purchase.guid, 'Готово'),
                        edit: () =>
                            handleStatusChange(props.purchase.guid, 'Черновик'),
                        edit_ready: () =>
                            handleStatusChange(
                                props.purchase.guid,
                                'Подготовка'
                            ),
                        ready_to_sent: () => {
                            handleStageChange(
                                props.purchase.guid,
                                'Подготовка к размещению'
                            )
                            handleStatusChange(
                                props.purchase.guid,
                                'Подготовка'
                            )
                        },
                        ready_to_eis: () => {
                            handleStageChange(
                                props.purchase.guid,
                                'Отправка в ЕИС'
                            )
                            handleStatusChange(
                                props.purchase.guid,
                                'Готово к отправке'
                            )
                        },
                        send_to_eis: () => {
                            handleToEisSendPopup()
                        },
                        update: () =>
                            updateContractFromEis(props.purchase.guid),
                        validation: () => {
                            props.handleValidation()
                            handleSave()
                        },
                    }}
                /> */}
                <div className="flex flex-1"></div>
                <FooterRightToolbarButtons
                    theme={props.theme}
                    purchaseAction={
                        !!(
                            props.purchaseAction ||
                            props.purchase.purchase_stage === 'Отправка в ЕИС'
                        )
                    }
                    actions={{
                        close: handleClose,
                    }}
                    isLoading={isSaving}
                />
            </div>
        </footer>
    )
}

export default Footer
